import { DecoratedWorkerShift } from "@/redux/actions/shifts.actions";

export const getPositionName = (
  s: Pick<DecoratedWorkerShift, "positionName" | "roleName">
) => (s.positionName ? `${s.positionName} (${s.roleName})` : s.roleName);
